import { useContext } from 'react';
import {
    SearchResultContext,
    SearchResultContextValue,
} from './SearchResultContext';

export const useSearchResults = (): SearchResultContextValue => {
    const context = useContext(SearchResultContext);

    if (!context) {
        console.warn(
            'useContext must be used inside a SearchResultContextProvider such as the one provided by the <Search> component'
        );
    }

    return context;
};
